import React from 'react';
import styles from './ActiveStatusBadge.module.scss';

/**
 * Компонент для відображення статусу активності
 * @param {boolean} active - Статус активності (true/false або enabled)
 * @param {string} activeText - Текст для активного статусу (за замовчуванням "Ввімкнений")
 * @param {string} inactiveText - Текст для неактивного статусу (за замовчуванням "Вимкнений")
 * @param {boolean} styled - Чи застосовувати стилі фону (за замовчуванням true)
 * @param {React.ReactNode} children - Додатковий вміст (наприклад, попередження)
 */
const ActiveStatusBadge = ({ 
  active, 
  activeText = "Ввімкнений", 
  inactiveText = "Вимкнений",
  styled = true,
  children 
}) => {
  const className = active 
    ? styles.active 
    : styles.inactive;

  const inlineStyle = styled
    ? (active 
        ? { backgroundColor: "#ccffcc" } 
        : { backgroundColor: '#dc3545', fontWeight: 'bold', color: '#fff' })
    : {};

  return (
    <span className={className} style={inlineStyle}>
      {active ? activeText : inactiveText}
      {children}
    </span>
  );
};

export default ActiveStatusBadge;
